import { VFC } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Maybe } from "graphql/jsutils/Maybe";
import { Paperclip } from "@phosphor-icons/react";

interface Props {
  url?: Maybe<string> | string;
}

const imageFileTypes = ["png", "jpg", "jpeg"];

export const FilePreview: VFC<Props> = ({ url }) => {
  if (!url) {
    return <div className="text-sm">No receipt</div>;
  }

  const fileType = url.split(".").pop();

  if (!fileType) {
    return (
      <div>
        <a href={url} target="_blank">
          {"receipt"}
        </a>
      </div>
    );
  }

  const isImage = imageFileTypes.includes(fileType);
  const filename = "receipt" + "." + fileType;

  const handleClick = (
    e: React.MouseEvent<HTMLButtonElement | HTMLDivElement>,
  ) => {
    e.stopPropagation();
  };

  return (
    <Dialog>
      <DialogTrigger
        onClick={handleClick}
        className="flex flex-row items-center"
      >
        <Paperclip className="mr-2 size-4" /> {filename}
      </DialogTrigger>
      <DialogContent onClick={handleClick} className="min-w-max p-6">
        <DialogHeader>
          {isImage ? (
            <img
              src={url}
              className="max-h-[90vh] max-w-[75vw] object-contain"
            />
          ) : (
            <iframe
              src={url}
              className="min-h-[80vh] min-w-[65vw] object-contain"
            />
          )}
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};
